import { isString } from '../../stringUtilities'

/**
 *
 * @param {T[]} array
 * @param {string | (arrayItem: T) => string} key
 * @returns { { [key: string]: T[] } }
 */
export function groupBy<T>(
  array: T[],
  key: string | ((arrayItem: T) => string | null),
): { [key: string]: T[] } {
  const defaultKeyFunc = (x: T) => {
    const val = x[key as keyof T]
    if ((val ?? null) === null) {
      return null
    }
    return String(val)
  }
  const keyFunc = isString(key)
    ? defaultKeyFunc
    : (key as (arrayItem: T) => string | null)

  return array.reduce((result: { [key: string]: T[] }, currentValue: T) => {
    const keyValue = keyFunc(currentValue)

    if (keyValue === null) {
      return result
    }

    if (result[keyValue] === undefined) {
      result[keyValue] = []
    }

    result[keyValue].push(currentValue)
    return result
  }, {})
}
